export default "__VITE_ASSET__BJOCB_Vh__"